<template>
  <button :aria-label="ariaLabel" class="btn" :class="[classes, customClasses]" @click="onClick" v-on="$listeners" :disabled="$props.disabled">
      <figure v-if="$slots.image">
        <slot name="image"></slot>
      </figure>
      <div class="text-center margin-auto btn__text" v-if="$slots.text">
        <slot name="text"></slot>
      </div>
  </button>
</template>

<script>
export default {
  name: 'btn',
  props: {
    customClasses: {
      type: Array,
      default: () => []
    },
    rounded: {
      type: Boolean,
      default: true
    },
    colour: {
      type: String,
      default: "black"
    },
    wide: Boolean,
    xlarge: Boolean,
    narrow: Boolean,
    large: Boolean,
    huge: Boolean,
    small: Boolean,
    square: Boolean,
    disabled: Boolean,
    border: Boolean,
    circular: Boolean,
    ariaLabel: String,
    left: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return [
        { 'btn-border': this.border },
        { 'btn-square': this.square },
        { 'btn-rounded': this.rounded },
        { 'btn-wd': this.wide },
        { 'btn-sm': this.small },
        { 'btn-lg': this.large },
        { 'btn-xl': this.xlarge },
        { 'btn-disabled': this.disabled },
        { 'btn-green': this.colour == 'green'},
        { 'btn-black': this.colour == 'black'},
        { 'btn-grey': this.colour == 'grey'},
        { 'btn-ghost': this.colour == 'ghost'},
        { 'btn-yellow': this.colour == 'yellow'},
        { 'btn-mauve': this.colour == 'mauve'},
        { 'btn-red': this.colour == 'red'},
        { 'btn-narrow': this.narrow},
        { 'btn-gold': this.colour == 'gold'},
        { 'btn-circular': this.circular},
        { 'btn-huge': this.huge},
        { 'btn-left': this.left},
      ];
    }
  },
  methods: {
    onClick(evt) {
      this.$emit('onClick', evt);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './button.scss';
</style>
